import { render, staticRenderFns } from "./StaffPackageManager.vue?vue&type=template&id=48bd5fe8&"
import script from "./StaffPackageManager.vue?vue&type=script&lang=ts&"
export * from "./StaffPackageManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports